import {
  Megaphone, ClipboardCheck, Network, CalendarDays, Users, BarChart3, MessageCircle, GraduationCap, Trophy, Award,
  IndianRupee, Star, MapPin, Clock, Laptop, BookOpen, Sparkles, Briefcase, UserCheck, Lightbulb, PenTool, Rocket,
} from 'lucide-react';

export const ROLES = [
  {
    id: 'campus-ambassador', icon: Megaphone, tag: 'Pan India · Part-time', title: 'Campus Ambassador Program',
    headline: 'Become the Career Connector at Your College!',
    text: 'Build your network, gain real-world experience and help fellow students take their next career step, while developing your own leadership and communication skills.',
    facts: [
      { icon: MapPin, label: 'Location', value: 'Pan India' },
      { icon: Laptop, label: 'Work Mode', value: 'Part-time | Flexible | Campus-based & Online' },
      { icon: Clock, label: 'Commitment', value: 'Approx. 2–3 hours per week' },
      { icon: BookOpen, label: 'Eligibility', value: 'Current UG & PG students, any stream' },
    ],
    sections: [
      {
        id: 'responsibilities', title: 'Your Role & Responsibilities', items: [
          { icon: Megaphone, title: 'Campus Outreach & Awareness', text: 'Introduce Elevate Careers to fellow students through college networks, clubs, societies and relevant digital communities.' },
          { icon: ClipboardCheck, title: 'Career Readiness Engagement', text: 'Encourage interested students to complete the free Career Readiness Check and explore career-readiness resources.' },
          { icon: Network, title: 'Talent Network Growth', text: 'Help students discover the Elevate Talent Network and relevant internships, entry-level opportunities and career initiatives.' },
          { icon: CalendarDays, title: 'Career Sessions & Events', text: 'Promote Elevate Careers sessions, workshops and student engagement activities.' },
          { icon: Users, title: 'Campus Community Building', text: 'Build relationships with students, contribute ideas and support meaningful campus initiatives.' },
          { icon: BarChart3, title: 'Engagement & Reporting', text: 'Provide brief weekly activity updates, share student feedback and communicate common career-related challenges.' },
        ],
      },
      {
        id: 'benefits', title: "What You'll Gain", items: [
          { icon: MessageCircle, title: 'Complimentary 1:1 Career Clarity Session', text: 'A personalized career guidance session with the Elevate Careers team.' },
          { icon: GraduationCap, title: 'Exclusive Career Mentorship', text: 'Access to a dedicated career-development workshop covering practical employability skills.' },
          { icon: Trophy, title: 'Real-World Leadership Experience', text: 'Practical exposure to communication, outreach, networking, coordination and community building.' },
          { icon: Award, title: 'Certificate of Completion', text: "An Elevate Careers Campus Ambassador Certificate after meeting the program's participation and completion requirements." },
          { icon: IndianRupee, title: 'Performance-Based Referral Incentives', text: '5% commission on eligible paid Elevate Careers services purchased through verified referrals, subject to the incentive terms communicated before onboarding.' },
          { icon: Star, title: 'Recognition & Future Opportunities', text: 'Outstanding ambassadors may receive additional recognition, personalized recommendations and consideration for future opportunities, subject to availability and selection.' },
        ],
      },
      {
        id: 'conditions', title: 'Important Role Conditions', bullets: [
          'No fixed stipend.',
          'Performance-based referral incentives are available on eligible paid services.',
          'Approximately 2–3 hours of participation per week are expected.',
          'No application or participation fee.',
          'Certificate eligibility depends on meaningful participation and completion requirements.',
          'Participation does not guarantee internships, employment or placement.',
        ],
      },
    ],
  },
  {
    id: 'founding-creator', icon: Sparkles, tag: 'Remote · New', title: 'Founding Creator & Growth Collaborator',
    headline: 'What if you could help build a brand before everyone knows about it?',
    text: "Are you someone who understands how content captures attention and communities grow? We're inviting creative students, content creators and aspiring growth marketers to explore fresh ideas for growing Elevate Careers India across Instagram, LinkedIn and student communities.",
    facts: [
      { icon: CalendarDays, label: 'Duration', value: '14 days' },
      { icon: MapPin, label: 'Location', value: 'Remote' },
      { icon: Clock, label: 'Commitment', value: 'Flexible and voluntary' },
      { icon: IndianRupee, label: 'Compensation', value: 'Unpaid' },
    ],
    sections: [
      {
        id: 'about', title: 'About the Role', paragraphs: [
          "Most people want to join brands that already have thousands of followers. We're looking for someone excited by the challenge of starting from scratch. Our student community is growing, our campus network is taking shape, and we've just launched on Instagram.",
          'Not just Instagram. Think LinkedIn, Reels, student communities, campus collaborations and organic growth. Maybe you create brilliant Reels, have helped grow a college page, or simply have exceptional ideas that haven’t had the right platform yet.',
        ],
      },
      {
        id: 'responsibilities', title: 'What You Can Explore', items: [
          { icon: Lightbulb, title: 'Explore growth ideas', text: 'Brainstorm and test fresh ideas with our founding team across Instagram, LinkedIn and student communities.' },
          { icon: PenTool, title: 'Create, if you wish', text: 'Contribute original content such as Reels, posts or carousels. Entirely optional, no mandatory deliverables.' },
          { icon: Rocket, title: 'Grow communities', text: 'Suggest campus collaborations and organic ways to reach more students.' },
        ],
      },
      {
        id: 'benefits', title: "What You'll Gain", items: [
          { icon: Award, title: 'Creative recognition', text: 'Credit for original ideas and content you choose to contribute.' },
          { icon: Briefcase, title: 'Portfolio experience', text: 'Real brand-building work you can show, from Reels to community growth.' },
          { icon: UserCheck, title: 'Founder mentorship', text: 'Explore ideas directly with our founding team.' },
        ],
      },
      {
        id: 'apply-how', title: 'How to Get Our Attention', bullets: [
          'Your Instagram or LinkedIn profile.',
          "One piece of content or creative project you're genuinely proud of.",
          "One idea you'd love to experiment with at Elevate.",
          "You don't need thousands of followers to impress us. You need originality, curiosity and the ability to connect with people.",
        ],
      },
      {
        id: 'conditions', title: 'Important Terms', bullets: [
          'This is a short, optional 14-day creative collaboration.',
          'Voluntary and unpaid, with no fixed hours and no mandatory deliverables.',
          'Any future paid opportunity would be discussed and agreed separately, and is not guaranteed.',
        ],
      },
    ],
  },
];
